import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const propertyReducer = (state = initialState.properties, action) => {
  switch (action.type) {
    case types.LOAD_PROPERTIES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_PROPERTIES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_PROPERTIES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_PROPERTIES_SUCCEEDED: {
      const { key, ids } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: true, ids};
      return result;
    }

    case types.LOAD_PROPERTY_DETAILS_STARTED: {
      const { propertyId } = action;
      let result = { ...state };
      result[propertyId] = { ...state[propertyId] };
      return result;
    }

    case types.LOAD_PROPERTY_DETAILS_SUCCEEDED: {
      const { propertyId } = action;
      let result = { ...state };
      result[propertyId] = Object.values(action.entities.propertyDetails);
      return result;
    }

    case types.LOAD_PROPERTY_DETAILS_FAILED: {
      let result = { ...state };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: propertyReducer
});
